var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRollingreserve(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4958_10532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25008 12.8332H8.75008C11.6667 12.8332 12.8334 11.6665 12.8334 8.74984V5.24984C12.8334 2.33317 11.6667 1.1665 8.75008 1.1665H5.25008C2.33341 1.1665 1.16675 2.33317 1.16675 5.24984V8.74984C1.16675 11.6665 2.33341 12.8332 5.25008 12.8332Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2084 6.99984C10.2084 8.77317 8.77341 10.2082 7.00008 10.2082C5.22675 10.2082 4.14758 8.42317 4.14758 8.42317M4.14758 8.42317H5.59425M4.14758 8.42317V10.0273M3.79175 6.99984C3.79175 5.2265 5.21508 3.7915 7.00008 3.7915C9.14091 3.7915 10.2084 5.5765 10.2084 5.5765M10.2084 5.5765V3.97234M10.2084 5.5765H8.78508",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4958_10532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollingreserve);
export default __webpack_public_path__ + "static/media/rollingreserve.222a7c553404f48c039a02552d1a092f.svg";
export { ForwardRef as ReactComponent };